import { faBan, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { atcb_action } from "add-to-calendar-button";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../hooks/use-auth";
import CallAPI from "../utils/call-api";
import 'add-to-calendar-button/assets/css/atcb.css';
import './schedule.css';

export default function Schedule() {
  const { id: userid } = useParams();
  const auth = useAuth();
  const [ user, setUser ] = useState(auth.user);
  const [loading, setLoading] = useState(false);
  const [classSessions, setClassSessions] = useState([]);
  const [isPassed, setIsPassed] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      if (userid) {
        const res = await CallAPI.get(`/user/${userid}`);
        setUser(res.data);
      }
      const res = await CallAPI.get('/class-session', { userid: user._id });
      setClassSessions(res.data);
      setLoading(false);
    };
    load();
  }, [user._id]);

  const handleCancelClick = (session) => {
    return async (evt) => {
      if (!window.confirm(`ต้องการยกเลิกคลาส\n${session.name}\n${moment(session.datetime).format('DD/MM/YY HH:mm')}`)) {
        return;
      }
      const data = { userid: user._id }
      const res = await CallAPI.put(`/class-session/${session._id}/user/remove`, data);
      setClassSessions(prev => {
        const i = prev.findIndex(s => s._id === res.data._id);
        if (i > -1) {
          prev.splice(i, 1);
        }
        return [...prev];
      });
      if (user._id === auth.user._id) {
        const numSessions = user.numSessions + 1;
        auth.setNumSessions(numSessions);
      }
    };
  };

  const handleCalendarClick = (session) => {
    return (evt) => {
      const datetime = moment(session.datetime);
      atcb_action({
        name: session.name,
        startDate: datetime.format('YYYY-MM-DD'),
        endDate: datetime.format('YYYY-MM-DD'),
        startTime: datetime.format('HH:mm'),
        endTime: datetime.add(1, 'h').format('HH:mm'),
        options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com'],
        timeZone: "Asia/Bangkok",
        iCalFileName: "Reminder-Event",
      });
    };
  };

  return (
    <>
    <h2>ตารางเรียนของ {user.name}</h2>
    {loading ?
      <div>loading</div>
      :
      <>
      <div className="button-group">
        <button disabled={!isPassed} onClick={() => setIsPassed(!isPassed)}>คลาสที่จอง</button>
        <button disabled={isPassed} onClick={() => setIsPassed(!isPassed)}>คลาสที่ผ่านมา</button>
      </div>
      <table className="list-schedule">
        <tbody>
        {classSessions.filter(s => {
          const now = moment().subtract(1, 'd');
          let passed = now > moment(s.datetime).add(1, 'h');
          return isPassed ? passed : !passed;
        }).map((s, i) => {
          const now = moment();
          const cancelable = auth.user.isAdmin || now < moment(s.datetime).subtract(12, 'h');
          return (
            <tr key={s._id}>
              <td>{i + 1}</td>
              <td>{moment(s.datetime).format('dddd')}</td>
              <td>{moment(s.datetime).format('DD/MM/YY HH:mm')}</td>
              <td>{s.name}</td>
              <td>
                {!auth.user.isAdmin && <button className="as-a btn-addCalendar" onClick={handleCalendarClick(s)}><FontAwesomeIcon icon={faCalendar}/></button>}
              </td>
              <td>
                {cancelable && <button className="as-a btn-cancel" onClick={handleCancelClick(s)}><FontAwesomeIcon icon={faBan}/></button>}
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
      </>
    }
    </>
  );
}